<template>
  <div class="content">
    <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
      <div class="teacherbook">
        <el-button type="primary" size="small" @click="addEduca()">创建教案心得</el-button>
      </div>
    </div>
    <div class="metter">
      <div class="nav" v-for="(item,index) in educaList" :key="index">
        <div class="navfirst">
          <div class="navfirstbox">
            <div
              v-if="item.type==1"
              class="navfirstbgc"
              style="background-color: rgb(82, 104, 226);"
            >心得</div>
            <div
              v-if="item.type==2"
              class="navfirstbgc"
              style="background-color: rgb(231, 118, 203)"
            >教案</div>
            <div style="font-size:16px" class="navfirstText">{{item.title}}</div>
          </div>
          <div style="margin-right:20px">
            <el-button type="primary" size="mini" plain @click="TeacherBlogsUpdate(item.id)">编辑</el-button>
            <el-button type="danger" size="mini" plain @click="TeacherBlogsDelete(item.id)">删除</el-button>
          </div>
        </div>
        <div class="navsecond">
          <p v-html="item.descript"></p>
        </div>
        <!-- <div class="navthirt">
          <div>
            <span>
              <img src="@/assets/resource/u231.svg" alt />
            </span>
            <span>
              <span style="font-size='14px'">{{item.readCount}}</span>
            </span>
            <span>
              <img src="@/assets/resource/u234.svg" alt />
            </span>
            <span>222</span>

            <span>
              <img src="@/assets/resource/点赞03_u2863.svg" alt />
            </span>
            <span>{{item.assistCount}}</span>
          </div>
          <div style="margin-right:10px;margin-top:2px">{{item.createTime}}</div>
        </div>-->
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuerys.page"
        :page-size="listQuerys.limit"
        layout=" total,prev, pager, next,jumper"
        :total="listQuerys.count"
      ></el-pagination>
    </div>

    <el-dialog
      class="dialog-mini"
      v-el-drag-dialog
      :close-on-click-modal="false"
      title="教案博客"
      :visible.sync="dialogVisibleEduca"
      width="60%"
    >
      <el-form
        :rules="rules"
        ref="educaData"
        label-position="right"
        label-width="100px"
        :model="educaData"
      >
        <div style="margin-left:100px;margin-top:10px">
          <el-form-item label="标题" prop="title">
            <el-input v-model="educaData.title" style="width:400px"></el-input>
          </el-form-item>

          <el-form-item :label="'是否评论'">
            <el-radio-group v-model="educaData.type">
              <el-radio :label="1">心得</el-radio>
              <el-radio :label="2">教案</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="描述" prop="descript">
            <el-input v-model="educaData.descript" style="width:400px"></el-input>
          </el-form-item>

          <el-form-item label="内容" prop="contents">
            <editors
              ref="editor"
              v-model="educaData.contents"
              :catchData="con"
              :isClear="true"
              v-if="dialogVisibleEduca"
              style="width:800px"
            ></editors>
          </el-form-item>

          <el-form-item :label="'是否评论'">
            <el-radio-group v-model="educaData.isTakl">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="'是否公开'">
            <el-radio-group v-model="educaData.isOpen">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEduca">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import editors from '@/components/editors';
import * as educat from '@/api/personcenter/index.js';
import elDragDialog from '@/directive/el-dragDialog';
export default {
  components: {
    editors,
  },
  directives: {
    elDragDialog,
  },
  data() {
    return {
      labledata: ['全部'],
      currentPage2: 1,
      lableindex: 0,
      dialogVisibleEduca: false,
      flag: true,
      con: '', //数据编辑时传回富文本的值
      educaData: {
        title: '',
        descript: '',
        contents: '',
        type: 1,
        isTakl: true,
        isOpen: true,
        createId: this.$store.state.User.ids,
      },
      rules: {
        title: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        contents: [
          { required: true, message: '内容不能为空', trigger: 'blur' },
        ],
        descript: [
          { required: true, message: '描述不能为空', trigger: 'blur' },
        ],
      },
      listQuerys: {
        page: 1,
        limit: 5,
        userId: this.$store.state.User.ids,
        title: '',
        count: 0,
      },
      educaList: '',
      addorupFlag: '',
    };
  },
  created() {
    this.getList();
  },
  methods: {
    lableArea(index, item) {
      this.lableindex = index;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.listQuerys.limit = val;
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.listQuerys.page = val;
      this.getList();
    },
    getList() {
      educat.TeacherBlogsLoad(this.listQuerys).then((res) => {
        // console.log(res);
        this.educaList = res.data;
        this.listQuerys.count = res.count;
      });
    },
    addEduca() {
      this.dialogVisibleEduca = true;
      this.addorupFlag = 'add';
      this.educaData.title = '';
      this.educaData.descript = '';
      this.educaData.contents = '';
      this.con = '';
      this.educaData.isTakl = true;
      this.educaData.isOpen = true;
      this.educaData.type = 1;
    },
    // change(val) {
    //     console.log(val)
    //     this.educaData.contents=val
    // },
    addOrEduca() {
      this.educaData.contents = this.$refs.editor.editorData;
      if (this.addorupFlag == 'add') {
        educat.TeacherBlogsAdd(this.educaData).then((res) => {
          this.dialogVisibleEduca = false;
          this.$message({
            showClose: true,
            message: '添加成功',
            type: 'success',
          });
          this.getList();
          // console.log(this.educaData)
        });
      } else {
        educat.TeacherBlogsUpdate(this.educaData).then((res) => {
          this.dialogVisibleEduca = false;
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success',
          });
          this.getList();
        });
      }
    },
    TeacherBlogsUpdate(id) {
      setTimeout(() => {
        this.dialogVisibleEduca = true;
        this.$refs.editor.abc(this.con);
      }, 500);
      this.dialogVisibleEduca = true;
      this.addorupFlag = 'Update';
      let a = {
        id: id,
      };
      educat.TeacherBlogsGet(a).then((res) => {
        this.educaData = res.result;
        this.con = res.result.contents;
        // console.log(this.con);
        console.log(this.$refs.editor);
        // this.flag=true
      });
    },
    TeacherBlogsDelete(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let a = [id];
        educat.TeacherBlogsDelete(a).then((res) => {
          // console.log(res);
          this.dialogVisibleEduca = false;
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          });
          this.getList();
        });
      });
    },
  },
};
</script>
<style scoped>
.content {
  /* width: 900px; */
  width: 100%;
  /* height: 1000px; */
  padding-bottom: 20px;
}
.heightlight {
  color: #409eff !important;
}
.header {
  width: calc(100% - 50px);
  height: 40px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
}
.header > div:nth-child(1) {
  width: 150px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
}
.teacherbook {
  position: relative;
  right: 20px;
  margin-right: 10px;
}
.header > div:nth-child(1):hover {
  color: #409eff;
}
.xian {
  width: 140px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.metter {
  display: flex;
  flex-wrap: wrap;
}

.nav {
  width: 830px;
  height: 112px;
  margin-top: 16px;
  border-radius: 10px;
  border: 1px solid #f2f2f2;
  padding-top: 12px;
  margin-left: 20px;
}
.nav:hover {
  box-shadow: 2px 2px 5px rgba(52, 194, 250, 0.969) !important;
}
.navfirst {
  font-weight: 700;
  padding-left: 20px;
  padding-bottom: 8px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f2;
}

.navfirstbox {
  display: flex;
  align-items: center;
}
.navfirstbgc {
  font-weight: 500;
  padding: 0 10px;
  height: 22px;
  line-height: 22px;
  border-radius: 5px;
  font-size: 14px;
  margin-right: 10px;
  color: #fff;
}
.navfirstText {
}
.navsecond {
  height: 75px;
  border-bottom: 1px solid #f2f2f2;
}
.navsecond > p {
  height: 75px;
  padding: 5px 10px;
  text-indent: 2em;
  font-size: 16px;
  line-height: 27px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.navthirt {
  padding-top: 5px;
  /* text-align: center; */
  padding-left: 20px;
  height: 30px;
  display: flex;
  justify-content: space-between;
}

.navthirt > div > span > img {
  width: 20px;
  height: 20px;
}
.navthirt > div > span:nth-child(1) {
  width: 42px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 24px;
  color: #999999;
  opacity: 1;
  vertical-align: middle;
}
.navthirt > div > span:nth-child(2) {
  width: 22px;
  height: 22px;
  margin-left: 5px;
  color: #7f7f7f;
}
.navthirt > div > span:nth-child(3) {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  vertical-align: middle;
  margin-left: 35px;
}
.navthirt > div > span:nth-child(4) {
  width: 22px;
  height: 22px;
  color: #7f7f7f;
  margin-left: 3px;
}
.navthirt > div > span:nth-child(5) {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  vertical-align: middle;
  margin-left: 35px;
}
.navthirt > div > span:nth-child(6) {
  width: 22px;
  height: 22px;
  color: #7f7f7f;
  margin-left: 3px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>